<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 col-md-7">
        <div class="card p-md-5 p-2">
          <div class="card-body">
            <div v-html="content.txt"></div>
            <a class="btn btn-primary float-end" :href="this.$accountUrl + '?redirect=vspR61cxeGlYDdudugS6'">{{content.form.submit}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Response} from "@/classes/response";
import {Validate} from "@/classes/validate";

export default {
  name: 'Login',
  props: ['initData','contents'],
  data(){
    this.initData.bigImage = 1
    return{
      email : null,
      emailError : null,
      password : null,
      passwordError : null
    }
  },
  computed:{
    content(){
      return this.contents.login
    }
  },
  methods:{
    login(){
      let validate = new Validate()

      //EMAIL
      this.emailError = validate.emptyField(this.email,this.content.errors.emailRequired)

      //PASSWORD
      this.passwordError = validate.emptyField(this.password,this.content.errors.passwordRequired)

      if (this.emailError || this.passwordError) {
        return false;
      }

      this.initData.loader = true
      let postData = {
        'email' : this.email,
        'password' : this.password
      }
      this.$axios.post('/api/v1/user/login', postData)
          .then((response) => {
            let responseData =  new Response().handle(response)
            this.initData.alerts.push({msg: responseData.msg, type: responseData.msgType})

            if(responseData.status===true) {
              this.initData.user.status = responseData.data.status
              this.initData.user.teamName = responseData.data.teamName
              this.initData.user.firstName = responseData.data.firstName
              this.initData.user.isTestTeam = responseData.data.isTestTeam
              localStorage.setItem('n120_session_hash',responseData.data.sC)
              this.$axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem('n120_session_hash')}`
            }
          })
          .catch(error => {
            console.log(error)
            let responseData =  new Response()
            responseData.errorHandle(error.response)
            this.initData.alerts.push({msg: responseData.msg, type: responseData.msgType})
          })
          .then(() => {
            this.initData.loader = false
          });
    }
  }

}
</script>
<style scoped>
.container{
  max-width: 1280px;
  padding-top: 2rem;
  padding-bottom: 6rem;
}
.card{
  background-color: rgba(255,255,255,0.9);
}
</style>
